<template>
  <i-bxs-coupon />
</template>
